import React from "react";
import TextExpand from "../../../components/TextExpand";

const SeoSection = ({ seoHtml }) => {
  if (!seoHtml) return null;

  return (
    <TextExpand
      html
      allowOriginalFormat
      shortText={seoHtml.slice(0, 300).replace(/<\/?(tr|td|ul|li|p|b|div|span|a)[^>]*(>|$)/gi, "")}
      fullText={seoHtml}
    />
  );
};

export default SeoSection;
